import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import api, { urlParamCharacter } from '../services/api';

export default class ClientsIndexPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      category: null,
    };
  }

  componentDidMount() {
    const { history } = this.props;

    api.get(`/clients_categories${urlParamCharacter}per_page=1&orderby=menu_order&order=asc`)
      .then((response) => {
        this.setState({
          category: response.data[0],
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }

        history.push('/not-found');
      });
  }

  render() {
    const { category } = this.state;

    if (category) {
      return <Redirect to={`/clients/${category.slug}`} />;
    }

    return null;
  }
}

ClientsIndexPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};
